<template>
  <Viewer class="exercise-detail" :isOpenBookCats="openBookCats"
    :linkBack="otherInfo ? { name: 'exercise', query: { lop: classId, mon: subjectId, tab: typeId } } : {}"
    :valOpenSidebar="typeOpenSidebar">
    <template v-if="otherInfo" v-slot:viewer_head_name>{{ otherInfo.subjectName }} - {{ otherInfo.title }}</template>
    <!-- <template v-if="otherInfo" v-slot:viewer_head_right>{{ versionApp }}</template> -->
    <template v-if="otherInfo" v-slot:viewer_head_right>
      <span v-if="screenWidth > 991" class="secondary-color-txt font-sanpro-light font-size-14 version">{{ versionApp
      }}</span>
      <!-- <div v-if="screenWidth < 992" class="cursor-pointer" @click="resetAnswers">
      <i class="icon-reset font-size-22 secondary-color-txt "></i>
  </div> -->
      <!-- <i class="icon-question font-size-20" @click="openModalNotiError"></i> -->
    </template>
    <template v-slot:viewr_body>
      <div class="exercise-detail__questions exercise-detail__questions__other" v-if="screenWidth > 991">
        <div class="exercise-detail__list position-rel">
          <transition name="slide-fade">
            <div class="item position-rel content-1">
              <div class="question-group" v-if="question && question.type && question.type === typeGroup">
                <PreviewQuestion :dataSource="question" :questions="[question]" :location="0" :preview="true"
                  :questionsData="question" @formatQuestion="getInfoQuestion" @answerMissing="handleAnswerMissing" />
                <div class="questions-child" v-if="question.listQuestionChild">
                  <div class="questions-child__item" v-for="(child, pos) of question.listQuestionChild" :key="pos">
                    <PreviewQuestion v-if="child" :dataSource="child" :location="pos" :parentIndex="0"
                      :isQuestionChild="true" :preview="true" :questionsData="question"
                      @formatQuestion="getInfoQuestion" />
                  </div>
                </div>
                <p v-if="txtMissingQuestionGroup" class="question-missing-answer color-err">{{ txtMissingQuestionGroup
                }}</p>
              </div>
              <div class="question-single" v-else-if="question">
                <PreviewQuestion :dataSource="question" :location="0" :preview="true" @formatQuestion="getInfoQuestion"
                  @answerMissing="handleAnswerMissing" />
              </div>
            </div>
          </transition>
        </div>
        <ExerciseGuide v-if="question && sliderQuestionList" :question="question" :handleShowGuide="showGuideContent" />
      </div>
      <div v-else class="exercise-detail__questions position-rel">
        <ExerciseQuestionDetail :question="question" :txtMissingQuestionGroup="txtMissingQuestionGroup"
          @answerMissing="handleAnswerMissing" />
      </div>
    </template>
    <!-- <template v-slot:viewer_sidebar_icon>
      <a href="javascript:;" :class="{'active': keySidebarActive === 'link'}" @click="openSidebar('link')" class="total-a"  data-toggle="tooltip" data-placement="left" title="Liên kết">
        <span class="icon-link font-size-24"><span class="path1"></span><span class="path2"></span></span>
      </a>
      <a href="javascript:;" :class="{'active': keySidebarActive === 'info'}" @click="openSidebar('info')" class="total-a"  data-toggle="tooltip" data-placement="left" title="Thông tin">
        <i class="icon-info"></i>
      </a>
    </template> -->
    <!-- <template v-slot:viewer_sidebar_content>
      <SidebarInfo :keySidebarActive="keySidebarActive" />
    </template> -->
    <template v-slot:viewer_toggle_cat_name>Danh sách</template>
    <template v-slot:viewer_footer_center>
      <SliderNameQuestion v-if="sliderQuestionList && sliderQuestionList.length > 0" :dataSource="sliderQuestionList"
        @handleNextCat="nextCatBook" @handlePrevCat="prevCatBook" />
    </template>
    <template v-slot:viewer_footer_mobile>
      <a href="javascript:;"
        class="font-size-16 font-sanpro-semibold display-block width-percentage-80 margin-center border-rd-20 text-center primary-bg-color mb-2"
        style="padding: 5px 0px">
        <span v-if="question && !question.isWorked" @click="checkAnswer" class="light-color">
          {{ question.type === typeDownAnswer ? 'Lưu đáp án' : 'Kiểm tra' }}
        </span>
        <span v-else-if="question && question.isWorked" class="light-color" @click="resetAnswers">Làm lại</span>
      </a>
    </template>
    <template v-slot:viewer_footer_right>
      <a v-if="question && !question.isWorked" href="javascript:;"
        class="btn btn-main font-size-16 font-sanpro-semibold border-rd-20 line-height-1-1 btn-min-w-120"
        :class="{ 'disabled': question && ((question.type === typeDrawShape || question.type === typeDownAnswer) || questionindexActive === 0 || question.isWorked || question.statusWorked) }"
        @click="checkAnswer">
        {{ question.type === typeDownAnswer ? 'Lưu đáp án' : 'Kiểm tra' }}
      </a>
      <a v-else-if="question && question.isWorked" href="javascript:;"
        class="btn btn-main font-size-16 font-sanpro-semibold border-rd-20 line-height-1-1 btn-min-w-120"
        @click="resetAnswers">
        Làm lại
      </a>
    </template>
    <template v-slot:viewer_sidebar_cat_head>
      <h2 class="book-viewer__cats__title primary-color-txt font-size-24 font-sanpro-semibold book-viewer__cats__wrap">
        Mục lục
      </h2>
    </template>
    <template v-slot:viewer_sidebar_cat_body>
      <ThematicSidebar ref="ThematicSidebar" class="exercise__cats__other__thematic" @resetQuestions="resetAnswerAllQuestion()" />
    </template>
    <template v-slot:viewer_footer>
      <ModalPreviewExercise v-if="infoQuestionPreview && Object.keys(infoQuestionPreview).length > 0" />
      <VituralKeyboard
        v-if="valVituralKeyboard.location > -1 && screenWidth > 991 && classId === idClass1 && subjectId === idMathSubject"
        :class="{ 'open-cat': openBookCats, 'over-height': valVituralKeyboard && valVituralKeyboard.isOverHaflScreen }" />
      <!-- <b-modal :id="idModalConfirmDelQuestion" hide-header hide-footer>
        <div class="modal-confirm border-rd-10 text-center">
          <p>Bạn chắc chắn muốn làm lại tất cả bài tập?</p>
          <div class="modal-confirm__action text-center">
            <b-button variant="danger" class="font-size-16 line-height-1" @click="$bvModal.hide('modal_confirm_reset')">Hủy</b-button>
            <b-button variant="success" class="font-size-16 line-height-1" @click="resetQuestionsList()">Làm lại</b-button>
          </div>
        </div>
      </b-modal> -->
      <audio v-if="actionPlayQuestionTrue" id="question_true" :src="correct" autoplay></audio>
      <audio v-if="actionPlayQuestionFalse" id="question_false" :src="incorrect" autoplay></audio>
    </template>
  </Viewer>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { TYPE_GROUP, TYPE_DRAW_SHAPE_ANSWER, TYPE_DOWN_ANSWER, TYPE_FILL_BLANK, TYPE_SELECT, TYPE_MATH_COL } from '@/modules/question/preview-question/_store/constants'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { scrollTo, callTimeDiff } from '@/helpers/functions'
import { APP_CONFIG } from '@/utils/constants'
import PreviewQuestion from '@/modules/question/preview-question/PreviewQuestion.vue'
import ExerciseQuestionDetail from '@/modules/exercises/_views/ExerciseQuestionDetail.vue'
import { getQuestionsSidebar, getQuestionDetail, getQuestionsByCat, getDetailOfOtherOrThematic, getQuestionListOfOtherOrThematic, getCatOfExerciseOtherOrThematic, saveUserWorkQuestion, resetResultCorrectQuestionOtherOrThematic, getQuestionListInSidebarOfThematicOrOther, resetResultWorkQuestion } from './../../_api/'
import { STORE_KEY, LOCAL_SAVE_QUESTIONS_WORKED, LOCAL_SAVE_CAT, LOCAL_SAVE_BOOK_ACTIVE, LOCAL_SAVE_EXERCISE_CLASS, LOCAL_QUESTIONS_DATA, TYPE_EXERCISE_OTHER, LOCAL_SAVE_CURRENT_THEMATIC } from "./../../_store/constants";
import VituralKeyboard from '@/modules/question/preview-question/VituralKeyboard.vue'
import { STORE_KEY as STORE_KEY_QUESTION } from '@/modules/question/preview-question/_store/constants'
import SliderNameQuestion from './../../_components/SliderNameQuestion.vue'
import ModalPreviewExercise from './../../_components/modal/ModalPreviewExercise.vue'
import { ID_CLASS_1, ID_MATH_SUBJECT } from '@/store/common/constants'
import { setContentMediaEditorShow } from '@/modules/question/preview-question/_store/helperQuestionContent'
const correct = require('@/assets/audio/correct.mp3')
const incorrect = require('@/assets/audio/incorrect.mp3')
import { getAuth } from '@/utils/jwt'
import { EMAIL_PUBLIC } from '@/store/auth/constants'

export default {
  name: 'OtherDetail',
  components: {
    vueCustomScrollbar,
    VituralKeyboard,
    SliderNameQuestion,
    PreviewQuestion,
    ThematicSidebar: () => import('./../../_components/thematic/ThematicSidebar.vue'),
    // SidebarInfo: () => import('./../../_components/thematic/SidebarInfo.vue'),
    ExerciseGuide: () => import('./../../_components/ExerciseGuide.vue'),
    Viewer: () => import('@/layouts/Viewer.vue'),
    ModalPreviewExercise,
    ExerciseQuestionDetail
  },
  data() {
    return {
      otherInfo: {},
      openBookCats: true,
      // questions: [],
      typeGroup: TYPE_GROUP,
      typeDrawShape: TYPE_DRAW_SHAPE_ANSWER,
      typeDownAnswer: TYPE_DOWN_ANSWER,
      typefillBlank: TYPE_FILL_BLANK,
      typeSelect: TYPE_SELECT,
      typeMatchCol: TYPE_MATH_COL,
      cdnUrl: APP_CONFIG.cdnUrl,
      question: null,
      showGuideContent: false,
      tabGuideActive: 0,
      questionindexActive: null,
      questionsSaved: [],
      sliderQuestionList: [],
      questionsLoaded: [],
      question: null,
      correct,
      incorrect,
      actionPlayQuestionTrue: false,
      actionPlayQuestionFalse: false,
      txtMissingQuestionGroup: '',
      handleNextPrevCat: '',
      keySidebarActive: '', // link & info
      typeOpenSidebar: {},
      idClass1: ID_CLASS_1,
      idMathSubject: ID_MATH_SUBJECT,
      startTimeQuestion: 0,
      collapseIdActivedefault: '',
      authInfo: {},
      firstSetCurrentChaper: true
    };
  },
  computed: {
    routerParams() {
      return this.$route.params;
    },
    classId() {
      return parseInt(this.$route.params.classId);
    },
    subjectId() {
      return parseInt(this.$route.params.subjectId);
    },
    screenWidth() {
      return window.innerWidth;
    },
    otherId() {
      return parseInt(this.$route.params.id);
    },
    typeId() {
      return parseInt(this.$route.params.typeId);
    },
    ...mapState('auth', ['loginPopupData']),
    ...mapState('common', ['versionApp']),
    ...mapState(STORE_KEY, ['catsFlatForExercise', 'infoQuestionPreview']),
    ...mapState(STORE_KEY_QUESTION, ['valVituralKeyboard']),
    ...mapGetters({
      actionCheckQuestion: `common/actionCheckQuestion`,
    }),
  },
  watch: {
    '$route.params.id': 'initPageAndRoute',
    actionCheckQuestion(newVal) {
      !newVal && this.setQuestionResult();
    },
    valVituralKeyboard(newVal) {
      if (newVal.ref) {
        document.getElementById(newVal.ref).value = newVal.val;
        document.getElementById(newVal.ref).focus();
      }
    },
    '$route.query.cauhoi': 'handleChangeQuestionDisplay',
    loginPopupData(newVal) {
      if (newVal && Object.keys(newVal).length) {
        this.authInfo = newVal;
        // this.getBookInfo();
        // if( !this.dataPractice.actived ) {
        //     this.$bvModal.show('modal_active_book');
        // }
      }
    },
  },
  created() {
    // this.getQuestionListOfSidebar();
    this.authInfo = getAuth();
    let dataCurrentThematic = localStorage.getItem(LOCAL_SAVE_CURRENT_THEMATIC) ? JSON.parse(localStorage.getItem(LOCAL_SAVE_CURRENT_THEMATIC)) : []
    if (dataCurrentThematic.length > 0) {
      for (let i = 0; i < dataCurrentThematic.length; i++) {
        if (dataCurrentThematic[i].email == this.authInfo.email && dataCurrentThematic[i].classId === this.classId && dataCurrentThematic[i].subjectId === this.subjectId && dataCurrentThematic[i].typeId === this.typeId) {

          this.$router.replace({ params: { ...this.$route.params, id: dataCurrentThematic[i].chapterId }, query: { cauhoi: 1 } })
          break
        }
      }
    }
  },
  mounted() {
    this.startTimeQuestion = new Date();
    
    this.initPageAndRoute()
    this.getInfoSaveLocal();
    // this.getCatsOfThematic();
  },
  destroyed() {
    this.resetValKeyboard();
    localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED)
    localStorage.removeItem(LOCAL_QUESTIONS_DATA)
  },
  methods: {
    ...mapActions('common', ['setLoading', 'setActionCheckQuestion']),
    ...mapActions(STORE_KEY, ['actionBookIndexOfBook', 'acSetParamFilterOtherThematic']),
    ...mapActions(STORE_KEY_QUESTION, ['setVituralKeyVal', 'setQuestionData4CheckAnswer', 'setQuestionList4CheckAnswer']),
    setCurrentThematic() {
      let dataCurrentThematic = localStorage.getItem(LOCAL_SAVE_CURRENT_THEMATIC) ? JSON.parse(localStorage.getItem(LOCAL_SAVE_CURRENT_THEMATIC)) : []
      if (dataCurrentThematic.length === 0) {
        dataCurrentThematic.push({ email: this.authInfo.email, classId: this.classId, subjectId: this.subjectId, typeId: this.typeId, chapterId: this.otherId })
      }
      else {
        let isUpdate = false
        for (let i = 0; i < dataCurrentThematic.length; i++) {
          if (dataCurrentThematic[i].email == this.authInfo.email && dataCurrentThematic[i].classId === this.classId && dataCurrentThematic[i].subjectId === this.subjectId && dataCurrentThematic[i].typeId === this.typeId) {
            dataCurrentThematic[i].chapterId = this.otherId
            isUpdate = true
            break
          }
        }
        if (!isUpdate) {
          dataCurrentThematic.push({ email: this.authInfo.email, classId: this.classId, subjectId: this.subjectId, typeId: this.typeId, chapterId: this.otherId })
        }
      }
      localStorage.setItem(LOCAL_SAVE_CURRENT_THEMATIC, JSON.stringify(dataCurrentThematic))
    },
    async initPageAndRoute() {

      let self = this
      if (!self.otherInfo || self.otherInfo.chapterId !== parseInt(this.$route.params.id)) {
        // self.setLoading(true)
        let info = await self.getInfoDetail()

        let questionList = await self.getQuestionListOfSidebar()
        if (info && info.questionLast && questionList && questionList.length > 0) {
          let indexQuestionLast = questionList.findIndex(ques => ques.questionId === parseInt(info.questionLast))
          if (indexQuestionLast > 0 && (!self.$route.query.cauhoi || (self.$route.query.cauhoi && parseInt(self.$route.query.cauhoi) !== (indexQuestionLast + 1)))) {
            self.$router.replace({ query: { cauhoi: indexQuestionLast + 1 } })
          }
        }
        self.fetchQuestionList()
      }
    },

    getInfoDetail() {
      if (!this.otherId) {
        return
      }
      return getDetailOfOtherOrThematic(this.otherId).then(res => {
        if (res && res.data && !res.errors) {
          this.otherInfo = res.data
          return res.data
        }
      })
    },

    handleToggleBookCats() {
      this.openBookCats = !this.openBookCats
    },

    setScrollToCat() {
      let elem = document.getElementById(`cat_row_${this.catCurrent.bookIndexId}`)
      if (elem) {
        let topPos = elem.offsetTop
        scrollTo(document.getElementById('book_viewer__cats'), topPos, 600)
      }
    },

    resetValKeyboard() {
      this.valVituralKeyboard && this.setVituralKeyVal({});
    },

    getInfoSaveLocal() {
      let catInfo = localStorage.getItem(LOCAL_SAVE_CAT);
      let practiceData = localStorage.getItem(LOCAL_SAVE_EXERCISE_CLASS);
      let questionData = localStorage.getItem(LOCAL_QUESTIONS_DATA);

      if (questionData && questionData !== null && questionData !== undefined) {
        this.questionsSaved = JSON.parse(questionData);
      } else {
        this.fetchQuestionList()
      }
    },

    getQuestionListOfSidebar() {
      let self = this;
      // self.setLoading(true);
      self.sliderQuestionList = [];
      if (!this.otherId) {
        return
      }
      return getQuestionListInSidebarOfThematicOrOther(self.otherId).then(res => {
        self.sliderQuestionList = res && res.data && !res.errors ? res.data : []
        if (res && res.data && res.data.length > 0) {
          self.getInfoQuestion()
          // Get question checked
          self.setQuestionResult()
        } else {
          self.setLoading(false)
        }
        return res.data
      }).catch().finally(() => self.setLoading(false))
    },

    getInfoQuestion() {
      let self = this;

      self.question = null
      // Hidden guide content
      self.showGuideContent = false
      // self.arrResultCorrect = []
      self.questionindexActive = parseInt(self.$route.query.cauhoi)
      if (self.questionindexActive > 0 && self.sliderQuestionList.length > 0) {
        // self.setLoading(true)
        let questionId = self.questionindexActive > self.sliderQuestionList.length ? self.questionindexActive : self.sliderQuestionList[self.questionindexActive - 1].questionId;
        let questionsLocalStorage = JSON.parse(localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED))

        if (questionsLocalStorage && questionsLocalStorage !== null && questionsLocalStorage !== undefined && questionsLocalStorage.length > 0) {
          let indexQuestionSave = questionsLocalStorage.findIndex(ques => ques.questionId === questionId)
          if (indexQuestionSave > -1) {
            self.question = questionsLocalStorage[indexQuestionSave]
            self.setLoading(false)
          } else {
            self.getQuestionDetail(questionId, questionsLocalStorage)
          }
        } else {
          self.getQuestionDetail(questionId)
        }
      }
    },

    getQuestionDetail(questionId, dataQuestion = []) {
      let self = this;
      // Get question detail
      getQuestionDetail(questionId).then(res => {
        if (res && res.data && !res.errors) {
          let typeQuestion = res.data.type === TYPE_GROUP ? 'group' : 'single'
          let questionContentReplace = setContentMediaEditorShow({ ...res.data }, typeQuestion)

          self.question = questionContentReplace;
          let dataSave = dataQuestion.length === 0 ? [questionContentReplace] : [...dataQuestion, questionContentReplace];
          self.saveLocalQuestion(dataSave);
        }
      }).catch().finally(() => self.setLoading(false));
    },

    saveLocalQuestion(data) {
      let dataSave = JSON.stringify(data);
      localStorage.setItem(LOCAL_SAVE_QUESTIONS_WORKED, dataSave);
    },

    setQuestionResult() {
      let self = this;
      let questionsLocalStorage = JSON.parse(localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED));
      if (questionsLocalStorage && questionsLocalStorage !== null && questionsLocalStorage !== undefined && questionsLocalStorage.length > 0) {
        questionsLocalStorage.map((ques, index) => {
          if (ques.statusWorked) {
            let resultCheckAnswer = ques.workedFail ? 'error' : 'success'
            let indexQuestionInList = self.sliderQuestionList.findIndex(queList => queList.questionId === ques.questionId)
            if (indexQuestionInList > -1) {
              self.sliderQuestionList[indexQuestionInList].answerStatus = resultCheckAnswer
              self.logQuestionWorked(resultCheckAnswer)
            }
          }
        })
      }
    },

    logQuestionWorked(status) {
      this.question['isTrue'] = status === 'success' ? true : false;
      this.question['isWorked'] = true;
    },

    openSidebar(type) {
      if (type !== null) {
        this.typeOpenSidebar = { type, isOpen: type === this.keySidebarActive ? false : true }
        this.keySidebarActive = type !== this.keySidebarActive ? type : ''
      }
    },

    handleCheckAnswerResult() {
      if (this.question.type === TYPE_GROUP) {
        this.txtMissingQuestionGroup = '';
      }
      (this.question.type !== this.typeDrawShape && this.question.type !== this.typeDownAnswer) && this.checkAnswer();
    },

    getQuestionData(val) {
      if (this.questionindexActive > 0) {
        if (this.sliderQuestionList[this.questionindexActive - 1] && this.sliderQuestionList[this.questionindexActive - 1]['current']) {
          this.sliderQuestionList[this.questionindexActive - 1]['current'] = false;
        }
        if (!val) {
          this.sliderQuestionList.map(ques => {
            ques.success && delete ques.success
            ques.error && delete ques.error
            ques.answerStatus && delete ques.answerStatus
          })
        }
        // this.questionindexActive = 1;
        // this.$router.push({name: 'exerciseOtherQuestion', params: {...this.routerParams, id: this.otherId, question: 0}})
      }
      if (!this.questionsSaved) {
        this.fetchQuestionList()
      }
    },

    fetchQuestionList() {
      let self = this;
      if (!self.otherId) {
        return
      }
      self.setLoading(true)
      // console.log('Question flat cats: ', self.catsFlatForExercise)
      getQuestionListOfOtherOrThematic(self.otherId).then(res => {
        if (res && res.data && !res.errors) {
          self.questionsSaved = res.data
          res.data.length > 0 && localStorage.setItem(LOCAL_QUESTIONS_DATA, JSON.stringify(res.data))
          if (res.data && res.data.length === 0) {
            self.handleNextPrevCat === 'prev' ? self.prevCatBook() : self.nextCatBook()
          } else if (res.data && res.data.length > 0) {
            const catCurr = self.catsFlatForExercise.find(cat => cat.chapterId === self.otherId)
            // console.log('Cat curR: ', catCurr, self.handleNextPrevCat)
            if (catCurr && catCurr.toggleId && catCurr.toggleId !== self.collapseIdActivedefault) {
              self.collapseIdActivedefault = catCurr.toggleId
              self.$root.$emit('bv::toggle::collapse', catCurr.toggleId)
            }
            // catCurr && catCurr.toggleId && this.$root.$emit('bv::toggle::collapse', catCurr.toggleId)
            // // Open collaspe default foe cat child
            // catCurr && catCurr.toggleId && this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
            //   console.log('isJustShown:', isJustShown, collapseId)
            //   if (collapseId !== catCurr.toggleId) {
            //     this.$root.$emit('bv::toggle::collapse', catCurr.toggleId)
            //   }
            // })
          }
        }
      }).catch().finally(() => self.setLoading(false))
    },

    resetAnswers() {
      resetResultWorkQuestion(this.question.questionId).then(res => {
        if (res && !res.errors) {
          this.formatQuestion()
          this.startTimeQuestion = new Date()
        }
      })
    },

    async resetAnswerAllQuestion() {
      let self = this;
      this.startTimeQuestion = new Date()
      if (!this.otherId) {
        return
      }
      resetResultCorrectQuestionOtherOrThematic(self.otherId).then(res => {
        if (res && !res.errors) {
          self.formatQuestion()
          // Promise.all([self.getQuestionListOfSidebar(), self.getQuestionData()]);
          // self.$router.push({name: 'exerciseThematicQuestion', params: {...self.routerParams, question: 0}})
          // self.$toast.success('Thực hiện làm lại bài tập thành công!')
        }
      })
    },

    formatQuestion() {
      localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED)
      this.question = {}
      this.sliderQuestionList = []
      // this.questionIdCheckAnswer = 0
      if (this.keySidebarActive === 'info') {
        this.questionIdCheckAnswer = {
          value: this.sliderQuestionList && this.sliderQuestionList[this.questionindexActive - 1] && this.sliderQuestionList[this.questionindexActive - 1].isTrue ? true : false,
          id: 0
        }
      }
      this.getQuestionListOfSidebar()
      // Get question info
      // Promise.all([this.getQuestionListOfSidebar(), this.getInfoQuestion()])
    },

    async checkAnswer() {
      let self = this;
      console.log('check answer');
      self.resetValKeyboard();
      if (self.question.type !== TYPE_DOWN_ANSWER) {
        self.setQuestionList4CheckAnswer([{ ...self.question }])
        self.setQuestionData4CheckAnswer({ ...self.question })
      }

      if (self.question.type === TYPE_GROUP) {
        self.txtMissingQuestionGroup = ''
        self.setQuestionData4CheckAnswer({ ...self.question, isGroup: true, parent: parent.questionId })
      }

      if (self.question.type !== TYPE_DOWN_ANSWER) {
        await self.setActionCheckQuestion(true);
      } else {
        self.question = { ...self.question, isTrue: true }
        self.saveQuestion2Local(self.question)
      }
      self.showGuideContent = true

      if (self.question.isTrue) {
        self.actionPlayQuestionTrue = true
        setTimeout(() => {
          document.getElementById('question_true').play()
        }, 5)
      } else {
        self.actionPlayQuestionFalse = true
        setTimeout(() => {
          document.getElementById('question_false').play()
        }, 5)
      }

      if (self.authInfo && self.authInfo.email !== EMAIL_PUBLIC) {
        let timeCal = callTimeDiff(this.startTimeQuestion)

        saveUserWorkQuestion(self.question, timeCal.minute)
      }

      setTimeout(() => {
        self.actionPlayQuestionTrue = false
        self.actionPlayQuestionFalse = false
      }, 4000)
    },

    saveQuestion2Local(questionCurr) {
      let questionsLocalStorage = localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED)
      if (!questionsLocalStorage || questionsLocalStorage === null || questionsLocalStorage === undefined) {
        this.saveLocalQuestion([questionCurr])
        return
      }

      questionsLocalStorage = JSON.parse(questionsLocalStorage)
      if (questionsLocalStorage.length === 0) {
        this.saveLocalQuestion([questionCurr])
        return
      }

      const indexQuestionInList = questionsLocalStorage.findIndex(ques => ques.questionId === questionCurr.questionId)
      if (indexQuestionInList > -1) {
        questionsLocalStorage[indexQuestionInList] = { ...questionCurr }
        this.saveLocalQuestion(questionsLocalStorage)
      }
    },

    handleAnswerMissing(valErr) {
      if (this.question.type === TYPE_GROUP) {
        this.txtMissingQuestionGroup = valErr
      }
      setTimeout(() => {
        this.showGuideContent = false
      }, 5)
    },

    prevCatBook() {
      this.handleNextPrevCat = 'prev'
      this.goToCat()
    },

    nextCatBook() {
      this.handleNextPrevCat = 'next'
      this.goToCat(1)
    },

    goToCat(type = 0) {
      console.log(this.catsFlatForExercise)
      let indexCatCurr = this.catsFlatForExercise.findIndex(cat => cat.chapterId === parseInt(this.$route.params.id));
      let catsLength = this.catsFlatForExercise.length
      this.resetValKeyboard()
      if ((type === 0 && indexCatCurr > 0) || (type > 0 && indexCatCurr < catsLength - 1)) {
        let targetCat = type === 0 ? this.catsFlatForExercise[indexCatCurr - 1] : this.catsFlatForExercise[indexCatCurr + 1]
        this.question = {}
        
        targetCat = this.$refs.ThematicSidebar.changeChapter(targetCat,this.catsFlatForExercise,type,indexCatCurr)
        if(!targetCat){
          return
        }

        this.$router.replace({ params: { ...this.$route.params, id: targetCat.chapterId }, query: { cauhoi: 1 } })
      }
      
      this.startTimeQuestion = new Date()
    },

    handleChangeQuestionDisplay() {
      let questionPosition = this.$route.query.cauhoi ? parseInt(this.$route.query.cauhoi) : 1
      if (questionPosition > this.sliderQuestionList.length) {
        this.$router.replace({ query: { cauhoi: 1 } })
      } else {
        this.getInfoQuestion()
      }
      // Reset time
      this.startTimeQuestion = new Date()
    }

  }
};
</script>

<style lang="scss" scoped>
.book-viewer {
  &__cats {
    &__title {
      padding: 0 0 10px !important;
    }
  }
}

.cat-head,
.cat-child li {
  @extend .display-flex;
  @extend .justify-content-between;

  >i {
    @extend .position-rel;
    top: 5px;
    @extend .font-size-20;
  }
}

@media screen and (max-width: 767px) {
  .exercise-detail {

    &__questions {
      padding: 15px;
    }

    .book-viewer {
      &__footer {
        &__cats {
          &:not(.is-full) {
            min-width: 35px !important;
            text-align: center;

            >i {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}

.btn-do-ex {
  height: 30px;
  line-height: 28px;
  padding: 0px 20px;
}

.exercise-detail {
  &__questions {
    padding-left: 30px;
  }

  &__list {
    padding: 30px 0 25px;
  }
}
</style>
